// extracted by mini-css-extract-plugin
module.exports =  {"OpenAPI":"OpenAPI-module__OpenAPI___s4RDd"};